module.exports = __webpack_public_path__ + "static/media/fiche_IPID_assurance_autonomie.faa4c7d7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/products/aa/documents/common/fiche_IPID_assurance_autonomie.pdf
// module id = 820
// module chunks = 40